import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const Megaphone = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 13.5a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4 8 8 0 0 1-1.6-4.8m-2-8v8m3-8a13 13 0 0 0 8.4-2.8 1 1 0 0 1 1.6.8v12a1 1 0 0 1-1.6.8 13 13 0 0 0-8.4-2.8H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(Megaphone) as SvgIcon;
export { ForwardRef as ReactComponent };
